import i18nInstance from 'i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, '@mc/next')

export const CONSTRAINTS = {
  emailInput: {
    presence: {
      message: t('sessions.campHeroCTAs.joinWaitListForm.emailRequired'),
    },
    email: {
      message: t('sessions.campHeroCTAs.joinWaitListForm.emailInvalid'),
    },
  },
}
